import EntityBase from '@/data/EntityBase';

import { Map } from 'immutable';

export default class ForecastState extends EntityBase({
  items: new Map(),
}) {}
